import {
  Component,
  ChangeDetectionStrategy,
  input
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'zui-project-location-chip',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule
  ],
  templateUrl: './project-location-chip.component.html',
  styleUrl: './project-location-chip.component.scss'
})
export class ProjectLocationChipComponent {
  // # Inputs
  locationLabel = input<string | null>(null);
}
